import React from 'react';
import './ProfileMenu.css';
import { HiOutlineLogout } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProfileMenu = ({ user,member }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const memberData = (member && member.status) ? member : {
    planName: 'Free Membership',
    status: 'Free',
    scheme: '',
    numberCard: '',
    planAmount: '',
    nextBillingDate: '',
  };
  const active = String(memberData.status || '').toLowerCase() === 'active';

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="profile-menu">
      <div className="profile-menu__header">
        <div className="profile-menu__info">
          <p className="profile-menu__name">{user?.displayName}</p>
          <p className="profile-menu__email">{user?.email}</p>
          <button
            className="profile-menu__manage-btn"
            onClick={() => navigate('/account')}
          >
            Manage profile
          </button>
        </div>
      </div>

      <hr className="profile-menu__divider" />

      <div className="profile-menu__membership">
        <p className="profile-menu__membership-title">Your membership</p>
        {active && (
        <div className="profile-menu__membership-card">
          <div className="profile-menu__membership-icon">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <circle cx="17" cy="17" r="16" fill="#F6B800" />
              <circle cx="17" cy="17" r="12" fill="white" />
              <circle cx="17" cy="17" r="9" fill="#F6B800" />
              <polygon points="17,12.5 20,17 17,21.5 14,17" fill="white" />
            </svg>
          </div>
          <div className="profile-menu__membership-info">
            <p className="profile-menu__membership-type">
              Premium Membership <span>$11/month</span>
            </p>
          </div>
        </div>
        )} 

        {!active  && (
        <div className="profile-menu__badge profile-menu__badge--free">
          <div>
            <div className="profile-menu__badge-title">Free Membership</div>
            <div className="profile-menu__badge-desc">
              Ideal for familiarising yourself with the platform
            </div>
          </div>
        </div>
        
        )} 
      </div>

      <button className="profile-menu__logout-btn" onClick={handleLogout}>
        <HiOutlineLogout className="profile-menu__logout-icon" />
        Log out
      </button>
    </div>
  );
};

export default ProfileMenu;
